import { useEffect, useState } from 'react';

export const useVarianceDrawerMockSources = ({ mockMode, bac } = {}) => {
  const [mockSources, setMockSources] = useState({ appsheet: null, trade: null, history: [] });

  useEffect(() => {
    let cancelled = false;
    if (!mockMode || !bac) {
      setMockSources({ appsheet: null, trade: null, history: [] });
      return () => { cancelled = true; };
    }
    const modulePath = './mockData.js';
    import(/* @vite-ignore */ modulePath).then(({ seedAppsheet, seedTrade, seedVarianceHistory }) => {
      if (!cancelled) {
        setMockSources({
          appsheet: seedAppsheet[bac] || null,
          trade: seedTrade[bac] || null,
          history: seedVarianceHistory[bac] || [],
        });
      }
    });
    return () => { cancelled = true; };
  }, [bac, mockMode]);

  return mockSources;
};
